import { CSSProperties, useMemo, useRef } from 'react';

import { Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { RelatedField } from '@atom/types/task';

const styles: Record<string, CSSProperties> = {
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 1.25rem 1rem 0',
    maxWidth: '7.25rem',
  },
  label: {
    color: colors.neutral.gray,
    fontSize: fonts.sm,
  },
  value: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

interface Props {
  relatedField: RelatedField;
  error?: boolean;
  disabled?: boolean;
}

const TaskRelatedField = ({
  relatedField,
  error = false,
  disabled = false,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const overflowing: boolean = useMemo(() => {
    if (!containerRef.current) {
      return false;
    }
    const { offsetWidth, scrollWidth } = containerRef.current;
    return offsetWidth < scrollWidth;
  }, [containerRef.current]);

  const labelStyle = {
    ...styles.label,
    ...(error ? { color: colors.utility.error } : {}),
  };

  const valueStyle = {
    ...styles.value,
    ...(disabled ? { color: colors.neutral.gray } : {}),
  };

  return (
    <div style={styles.fieldContainer}>
      <div style={labelStyle}>* {relatedField.title}</div>
      <div ref={containerRef} style={valueStyle}>
        {!overflowing ? (
          <span>{relatedField.value || '-'}</span>
        ) : (
          <Tooltip title={relatedField.value}>
            <span>{relatedField.value || '-'}</span>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default TaskRelatedField;
